import { noop, get } from 'lodash';
import {
  ROLLBACK_PROJECT,
  SELECT_PROJECT,
} from 'store/services/project/actionTypes';
import { LOGOUT_USER_SUCCESS } from 'store/services/session/actionTypes';

export default (reducerName, initialState, reducerHandlers = noop) => (
  state = initialState,
  action = {},
) => {
  const handlers = {
    [`GET_${reducerName}_ALL_REQUEST`]: () => ({
      ...state,
      all: {
        ...state.all,
        isLoading: true,
      },
    }),
    [`GET_${reducerName}_ALL_SUCCESS`]: () => ({
      ...state,
      all: {
        ...state.all,
        isLoading: false,
        data: action.payload.items,
      },
    }),
    [`GET_${reducerName}_ALL_ERROR`]: () => ({
      ...state,
      all: {
        ...state.all,
        isLoading: false,
        error: action.payload.error,
      },
    }),
    [`GET_${reducerName}_LIST_REQUEST`]: () => ({
      ...state,
      list: {
        ...state.list,
        isLoading: true,
      },
    }),
    [`GET_${reducerName}_LIST_SUCCESS`]: () => ({
      ...state,
      list: {
        ...state.list,
        isLoading: false,
        data: {
          ...state.list.data,
          items: action.payload.items,
          count: action.payload.count,
        },
      },
    }),
    [`GET_${reducerName}_LIST_ERROR`]: () => ({
      ...state,
      list: {
        ...state.list,
        isLoading: false,
        error: action.payload.error,
      },
    }),
    [`ADD_${reducerName}_REQUEST`]: () => ({
      ...state,
      add: {
        ...state.add,
        isLoading: true,
      },
    }),
    [`ADD_${reducerName}_SUCCESS`]: () => ({
      ...state,
      add: {
        ...state.add,
        isLoading: false,
      },
      show: {
        ...state.show,
        data: action.payload.item,
      },
    }),
    [`ADD_${reducerName}_ERROR`]: () => ({
      ...state,
      add: {
        ...state.add,
        isLoading: false,
        error: action.payload.error,
      },
    }),
    [`GET_${reducerName}_REQUEST`]: () => ({
      ...state,
      show: {
        ...state.show,
        isLoading: true,
      },
    }),
    [`GET_${reducerName}_SUCCESS`]: () => ({
      ...state,
      show: {
        ...state.show,
        data: action.payload.item,
        isLoading: false,
      },
    }),
    [`GET_${reducerName}_ERROR`]: () => ({
      ...state,
      show: {
        ...state.show,
        isLoading: false,
        error: action.payload.error,
      },
    }),
    [`UPDATE_${reducerName}_REQUEST`]: () => ({
      ...state,
      update: {
        ...state.update,
        isLoading: true,
      },
    }),
    [`UPDATE_${reducerName}_SUCCESS`]: () => ({
      ...state,
      update: {
        ...state.update,
        isLoading: false,
      },
      show: {
        ...state.show,
        data: {
          ...state.show.data,
          ...action.payload.item,
        },
      },
    }),
    [`UPDATE_${reducerName}_ERROR`]: () => ({
      ...state,
      update: {
        ...state.update,
        isLoading: false,
        error: action.payload.error,
      },
    }),
    [`DELETE_${reducerName}_REQUEST`]: () => ({
      ...state,
      delete: {
        ...state.delete,
        isLoading: true,
      },
    }),
    [`DELETE_${reducerName}_SUCCESS`]: () => ({
      ...state,
      show: {
        ...state.show,
        data: {},
      },
      delete: {
        ...state.delete,
        isLoading: false,
      },
    }),
    [`DELETE_${reducerName}_ERROR`]: () => ({
      ...state,
      delete: {
        ...state.delete,
        isLoading: false,
        error: action.payload.error,
      },
    }),
    [`UPDATE_${reducerName}_LIST_PAGINATION_OPTIONS`]: () => ({
      ...state,
      list: {
        ...state.list,
        paginationOptions: action.payload.paginationOptions,
      },
    }),
    [`UPDATE_${reducerName}_LIST_FILTER_OPTIONS`]: () => ({
      ...state,
      list: {
        ...state.list,
        filterOptions: action.payload.filterOptions,
      },
    }),
    [`UPDATE_${reducerName}_LIST_OPTIONS`]: () => ({
      ...state,
      list: {
        ...state.list,
        filterOptions: action.payload.filterOptions,
        filterParams: action.payload.filterParams,
        paginationOptions: action.payload.paginationOptions,
      },
    }),
    [`SELECT_${reducerName}`]: () => ({
      ...state,
      show: {
        ...state.show,
        data: action.payload.item,
      },
    }),
    [`DESELECT_${reducerName}`]: () => ({
      ...state,
      show: {
        ...state.show,
        data: {},
      },
    }),
    [`PARTIAL_IMPORT_${reducerName}_REQUEST`]: () => ({
      ...state,
      partialImport: {
        isLoading: true,
        error: '',
        importedResources: null,
      },
    }),
    [`PARTIAL_IMPORT_${reducerName}_COMPLETE`]: () => ({
      ...state,
      partialImport: {
        isLoading: false,
        error: action.error,
        importedResources: get(action, 'payload.importedResources', null),
      },
    }),
    [`PARTIAL_EXPORT_${reducerName}_CANCEL`]: () => ({
      ...state,
      partialExport: {
        isLoading: false,
        error: '',
      },
    }),
    [`PARTIAL_EXPORT_${reducerName}_REQUEST`]: () => ({
      ...state,
      partialExport: {
        isLoading: true,
        error: '',
      },
    }),
    [`PARTIAL_EXPORT_${reducerName}_COMPLETE`]: () => ({
      ...state,
      partialExport: {
        isLoading: false,
        error: action.error,
      },
    }),
    [LOGOUT_USER_SUCCESS]: () => ({
      ...state,
      show: {
        isLoading: false,
        error: '',
        data: {},
      },
    }),
    [SELECT_PROJECT]: () => ({
      ...state,
      ...initialState,
    }),
    [ROLLBACK_PROJECT]: () => ({
      ...state,
      ...initialState,
    }),
    ...reducerHandlers(state, action),
  };

  const matchingHandler = handlers[action.type];

  if (matchingHandler) {
    return matchingHandler(state, action);
  }

  return state;
};
